// extracted by mini-css-extract-plugin
export var blue = "bv_fB";
export var button = "bv_cd";
export var label = "bv_cy";
export var orange = "bv_fC";
export var white = "bv_fD";